<template>
  <div>
    <el-dialog
      title="Configurar topes de ISR"
      :visible.sync="isVisible"
      @close="onClose"
      width="60%"
    >
      <el-form
        v-model="ISRtopForm"
        ref="ISRtopForm"
        :rules="ISRtopFormRules"
        label-position="top"
        class="demo-ruleForm"
      >
        <el-row>
          <el-form-item label="Selecciona el Año" prop="year">
            <el-date-picker
              v-model="ISRtopForm.year"
              type="year"
              placeholder="selecciona el año"
              size="small"
            >
            </el-date-picker>
          </el-form-item>
        </el-row>
        <el-row>
          <el-col :span="7">
            <el-form-item label="Tope maximo">
              <el-input
                type="number"
                class="inputNumber"
                v-model="ISRtopForm.maxTop"
                :precision="2"
                :controls="false"
                size="small"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7" :offset="1">
            <el-form-item label="Monto Maximo a reducir">
              <el-input
                type="number"
                class="inputNumber"
                v-model="ISRtopForm.maxAmount"
                :precision="2"
                :controls="false"
                size="small"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7" :offset="1">
            <el-form-item label="Porcentaje Maximo a reducir">
              <el-input
                type="number"
                class="inputNumber"
                v-model="ISRtopForm.maxPercentage"
                :precision="2"
                :controls="false"
                size="small"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="7">
            <el-form-item label="Tope Intermedio">
              <el-input
                type="number"
                class="inputNumber"
                v-model="ISRtopForm.IntermTop"
                :precision="2"
                :controls="false"
                size="small"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7" :offset="1">
            <el-form-item label="Monto Intermedio a reducir">
              <el-input
                type="number"
                class="inputNumber"
                v-model="ISRtopForm.intermAmount"
                :precision="2"
                :controls="false"
                size="small"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7" :offset="1">
            <el-form-item label="Porcentaje Intermedio a reducir">
              <el-input
                type="number"
                class="inputNumber"
                v-model="ISRtopForm.intermPercentage"
                :precision="2"
                :controls="false"
                size="small"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="7">
            <el-form-item label="Tope minimo">
              <el-input
                type="number"
                class="inputNumber"
                v-model="ISRtopForm.minTop"
                :precision="2"
                :controls="false"
                size="small"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7" :offset="1">
            <el-form-item label="Monto Minimo a reducir">
              <el-input
                type="number"
                class="inputNumber"
                v-model="ISRtopForm.minAmount"
                :precision="2"
                :controls="false"
                size="small"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7" :offset="1">
            <el-form-item label="Porcentaje Minimo a reducir">
              <el-input
                type="number"
                class="inputNumber"
                v-model="ISRtopForm.minPercentage"
                :precision="2"
                :controls="false"
                size="small"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer">
        <el-button type="info" @click="onClose">Cancelar</el-button>
        <el-button type="primary" @click="ApplyISRtops">Aplicar</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "ISRtopConfig",
  props: {
    visibility: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      ISRtopForm: {
        year: "",
        minTop: 0,
        IntermTop: 0,
        maxTop: 0,
        maxAmount: 0,
        intermAmount: 0,
        minAmount: 0,
        maxPercentage: 0,
        intermPercentage: 0,
        minPercentage: 0
      },
      ISRtopFormRules: {
        /*
        year: [
          {required: true, message: 'Por favor seleccione el año', trigger: 'blur' }
        ]
        */
      }
    };
  },
  created() {
    /*
    const actualDate = new Date();
    this.ISRtopForm.year = actualDate.getFullYear();
    */
  },
  computed: {
    isVisible() {
      return this.visibility;
    }
  },
  methods: {
    onClose() {
      this.$refs["ISRtopForm"].resetFields();
      this.$emit("closingISRCOnfig");
    },
    ApplyISRtops() {
      const params = {
        Year: this.ISRtopForm.year,
        TopeMin: this.ISRtopForm.minTop,
        TopeInterm: this.ISRtopForm.IntermTop,
        TopeMax: this.ISRtopForm.maxTop,
        MaxPercentajeToRest: this.ISRtopForm.maxPercentage,
        MinPercentajeToRest: this.ISRtopForm.minPercentage,
        IntermPercentajeToRest: this.ISRtopForm.intermPercentage,
        MaxAmountToRest: this.ISRtopForm.maxAmount,
        MinAmountToRest: this.ISRtopForm.minAmount,
        IntermAmountToRest: this.ISRtopForm.intermAmount
      };
      /*
      this.$refs["ISRtopForm"].validate((valid) => {
        if (valid) {
          */

      const year = new Date(this.ISRtopForm.year).getFullYear();

      if (this.ISRtopForm.year !== "") {
        params.Year = year;
        this.$http.post("/api/Payroll/insertISRtops", params).then((resp) => {
          resp;
          this.$refs["ISRtopForm"].resetFields();
          this.$emit("rechargeISRtopData");
        });
      } else {
        this.$message.error("Debe seleccionar el año");
      }
      /*
        }
      });
      */
    }
  }
};
</script>

<style scoped>
.inputNumber {
  width: 50%;
}
</style>
>
